// extracted by mini-css-extract-plugin
export var reactMarkDown = "markdown-styles-module--reactMarkDown--3NsrA";